import {Component, EventEmitter, OnInit, Output,} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {getLabels, SearchModel,} from 'src/app/domain/appeloffre/app-offre-search';
import {CriteriaSearch} from 'src/app/domain/CriteriaSearch';

import {icons} from 'src/app/ui/icons';
import {CommmCode} from 'src/app/utils/constante/CommonCode';
import {AppTranslateService} from '../../../../modules/services/translate/app-translate.service';
import * as moment from 'moment';
import {SharedSearchService} from '../../accueil/common/shared-search.service';

export const CONSTANTE_SQL = {
    EQUALS: '=',
    DIFFERENCE: '!=',
    LIKE: 'like',
    NOT_LIKE: 'not_like',
    IN: 'in',
    BETWEEN: 'between',
    SUPERIOR: '>',
    SUPERIOR_EQUALS: '>=',
    INFERIOR: '<',
    INFERIOR_EQUALS: '<=',
    UPPER: 'upper',
    UPPER_DIFFERENCE: 'upper_diff',
    UPPER_LIKE: 'upper_like',
    UPPER_NOT_LIKE: 'upper_not_like',
};

@Component({
    selector: 'app-offers-filtre',
    templateUrl: './offers-filtre.component.html',
    styleUrls: ['./offers-filtre.component.css'],
})
export class OffersFiltreComponent implements OnInit {
    panelOpenState = false;

    @Output() search = new EventEmitter<Array<CriteriaSearch>>();
    commmCode = CommmCode;
    form = this.formBuilder.group({
        bidNo: this.formBuilder.control(null),
        bidNmFr: this.formBuilder.control(null),
        publicDt: this.formBuilder.control(null),
        publicDt_end: this.formBuilder.control(null),
        regType: this.formBuilder.control(null),
        startDate: this.formBuilder.control(null),
        bdRecvEndDt: this.formBuilder.control(null),
        bdRecvEndDt_end: this.formBuilder.control(null),
        financialMethodStrFr: this.formBuilder.control(null),
        executionPlaceStrFr: this.formBuilder.control(null),
        procedureTypeStrFr: this.formBuilder.control(null),
        bizKindStrFr: this.formBuilder.control(null),
        bizKindStrAr: this.formBuilder.control(null),
        pbkStrFr: this.formBuilder.control(null),
        onOffTypeStrId: this.formBuilder.control(null),
        bidNmAr: this.formBuilder.control(null),
        pbkStrAr: this.formBuilder.control(null),
        procedureTypeStrAr: this.formBuilder.control(null),
        bidInstNm: this.formBuilder.control(null),
    });
    labels = getLabels();

    icons = icons;

    constructor(
        private formBuilder: FormBuilder,
        private apptranstlte: AppTranslateService,
        private sharedService: SharedSearchService
    ) {
    }

    ngOnInit() {
    }

    getFormControl(key: keyof SearchModel) {
        return this.form.get(key) as FormControl;
    }

    submit() {
        const options = [];
        //     console.log("xwwww",this.form.value.publicDt._d)
        if (
            this.form.value.publicDt != undefined ||
            this.form.value.publicDt != null
        ) {
            var date_formatted_publicDt_start = moment(
                this.form.value.publicDt._d
            ).format('YYYY-MM-DD');
        }
        if (
            this.form.value.publicDt_end != undefined ||
            this.form.value.publicDt_end != null
        ) {
            var date_formatted_publicDt_end = moment(
                this.form.value.publicDt_end._d
            ).format('YYYY-MM-DD');
        }
        if (
            this.form.value.bdRecvEndDt != undefined ||
            this.form.value.bdRecvEndDt != null
        ) {
            var date_formatted_bdRecvEndDt = moment(
                this.form.value.bdRecvEndDt._d
            ).format('YYYY-MM-DD');
        }
        if (
            this.form.value.bdRecvEndDt_end != undefined ||
            this.form.value.bdRecvEndDt_end != null
        ) {
            var date_formatted_bdRecvEndDtt_end = moment(
                this.form.value.bdRecvEndDt_end._d
            ).format('YYYY-MM-DD');
        }

        options.push(
          new CriteriaSearch(
                'bidNo',
                this.form.value.bidNo?this.form.value.bidNo.trim() : null,
                'upper_like'
            ),
            new CriteriaSearch(
                'bidNmFr',
                this.form.value.bidNmFr || undefined,
                'upper_like'
            ),

            new CriteriaSearch(
                'bidNmAr',
                this.form.value.bidNmAr || undefined,
                'upper_like'
            ),
            new CriteriaSearch(
                'bizKindStrId',
                this.form.value.bizKindStrFr || undefined,
                'equals'
            ),
            new CriteriaSearch(
                'bizKindStrId',
                this.form.value.bizKindStrAr || undefined,
                'equals'
            ),
            new CriteriaSearch(
                'pbkStrId',
                this.form.value.pbkStrFr || undefined,
                'equals'
            ),
            new CriteriaSearch(
                'pbkStrId',
                this.form.value.pbkStrAr || undefined,
                'equals'
            ),
            new CriteriaSearch(
                'publicDt',
                date_formatted_publicDt_start || undefined,
                '>='
            ),
            new CriteriaSearch(
                'publicDt',
                date_formatted_publicDt_end || undefined,
                '<='
            ),
            new CriteriaSearch(
                'bdRecvEndDt',
                date_formatted_bdRecvEndDt || undefined,
                '>='
            ),
            new CriteriaSearch(
                'bdRecvEndDt',
                date_formatted_bdRecvEndDtt_end || undefined,
                '<='
            ),
            new CriteriaSearch(
                'financialMethodStrId',
                this.form.value.financialMethodStrFr || undefined,
                '='
            ),
            new CriteriaSearch(
                'executionPlaceStrId',
                this.form.value.executionPlaceStrFr || undefined,
                '='
            ),
            new CriteriaSearch(
                'procedureTypeStrId',
                this.form.value.procedureTypeStrFr || undefined,
                '='
            ),
            new CriteriaSearch(
                'procedureTypeStrId',
                this.form.value.procedureTypeStrAr || undefined,
                '='
            ),
            new CriteriaSearch('onOffTypeStrId', this.form.value.onOffTypeStrId, '='),
            new CriteriaSearch(
                'procedureTypeStrId',
                this.form.value.procedureTypeStrFr || undefined,
                '='
            ),
            new CriteriaSearch('onOffTypeStrId', this.form.value.onOffTypeStrId, '='),
            new CriteriaSearch('bidInstNm', this.form.value.bidInstNm, 'equals')
        );
        this.search.emit(options);
    }

    getlang() {
        return this.apptranstlte.getDefaultLang();
    }

    reset() {
        this.form.reset();
        this.submit();
    }
}
